module.exports = __webpack_public_path__ + "img/step_7.bca52d1d.webp";